export default function HeroSection() {
  return (
    <section className="relative w-full h-[63vh] md:h-[86vh] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/08d9908a-2395-4ac3-82a1-6049451d0d9d/ff818ae6-3b90-42a7-b2a8-eb062c881013_compressed_unnamed.webp"
          alt="GIAZO モデルハウス内観"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {/* Content - ReFaプレゼント at visual center */}
      <div className="absolute inset-0 z-10 flex items-center justify-center px-4 md:px-16">
        <div className="flex flex-col items-center">
          {/* GIAZOご来場キャンペーン */}
          <p
            className="font-heading text-[17px] md:text-[26px] tracking-[0.08em] text-white mb-3 md:mb-4 leading-relaxed"
            style={{ fontWeight: 300 }}
          >
            GIAZOご来場キャンペーン
          </p>

          {/* ReFaプレゼント - dead center of image */}
          <h1
            className="font-heading text-[40px] md:text-[76px] lg:text-[92px] tracking-[0.06em] leading-[1.15] text-white text-center"
            style={{ fontWeight: 300 }}
          >
            <span style={{ fontWeight: 500 }}>ReFa</span>プレゼント
          </h1>

          {/* 先着となります */}
          <p
            className="font-sans text-[15px] md:text-[18px] tracking-[0.05em] text-white mt-3 md:mt-4"
            style={{ fontWeight: 300 }}
          >
            ご予約でご来場の方の中から抽選で100名様
          </p>

          {/* 開催期間 */}
          <p
            className="font-sans text-[1.5rem] tracking-[0.06em] text-white mt-8"
            style={{ fontWeight: 300 }}
          >
            開催期間：2026.7.20[mon] 〜 8.30[sun]
          </p>
        </div>
      </div>
    </section>
  );
}